module.exports = __webpack_public_path__ + "img/bithumb.6eb745de.png";